import { InsuranceInfoCard } from 'Components/InsuranceInfoCard';
import React from 'react';
import { getAppText } from 'Utils/text';

export const MoveInsuranceInfoCard = (): React.ReactElement => {
  return (
    <InsuranceInfoCard
      title={getAppText('cancel.infoCard.moveInsurance.title')}
      description={getAppText('cancel.infoCard.moveInsurance.description')}
      maxWidth="400px"
    />
  );
};
